<div class="info">
	<mat-icon class="spin">autorenew</mat-icon>
	<div>Processing audio... </div>
</div>
